import { render, staticRenderFns } from "./WealthPerformanceV2.vue?vue&type=template&id=02252832&scoped=true"
import script from "./WealthPerformanceV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./WealthPerformanceV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WealthPerformanceV2.vue?vue&type=style&index=0&id=02252832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02252832",
  null
  
)

export default component.exports